import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
} from "@chakra-ui/react";

import { IFormField } from "./fieldTypes";

/**
 * JsonForm Text Field component.
 * @param props see {@link IFormField}
 */
function DateField({
  field,
  isRequired,
  register,
  disabled = false,
  errorMessage = "",
}: IFormField) {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errorMessage}>
      <FormLabel>{field.label}</FormLabel>
      <Input
        {...register(field.fieldName, field.config)}
        type="date"
        placeholder={field.placeholder || field.fieldName}
        autoComplete={field.autocomplete}
        disabled={disabled}
      />
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
      {!errorMessage && field.helperText ? (
        <FormHelperText>{field.helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
}

export { DateField };
